function getWeekDaysForBaseDate(
    baseDateInput: Date,
    startWeekOn: 'sunday' | 'monday' = 'sunday'
): {
    days: {
        day: number
        weekday: string
        isToday: boolean
        timestamp: number
    }[]
    range: {
        start: number
        end: number
    }
} {
    const baseDate = new Date(baseDateInput)
    const todayString = baseDate.toDateString()
    const adjustedDate = new Date(baseDate)

    const dayOfWeek = adjustedDate.getDay()
    let offset: number
    if (startWeekOn === 'monday') {
        offset = dayOfWeek === 0 ? 6 : dayOfWeek - 1
    } else {
        offset = dayOfWeek
    }

    // Set first day of week based on chosen start
    const firstDayOfWeek = new Date(
        adjustedDate.getFullYear(),
        adjustedDate.getMonth(),
        adjustedDate.getDate() - offset
    )
    firstDayOfWeek.setHours(0, 0, 0, 0)

    // Define day names based on start day
    const daysOfWeek =
        startWeekOn === 'monday'
            ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

    // Calculate week range timestamps
    const range = {
        start: firstDayOfWeek.getTime(),
        end:
            new Date(
                firstDayOfWeek.getFullYear(),
                firstDayOfWeek.getMonth(),
                firstDayOfWeek.getDate() + 7
            ).getTime() - 1
    }

    const currentWeekDays = []
    for (let i = 0; i < 7; i++) {
        const currentDay = new Date(firstDayOfWeek)
        currentDay.setDate(firstDayOfWeek.getDate() + i)
        currentWeekDays.push({
            day: currentDay.getDate(),
            weekday: daysOfWeek[i],
            isToday: currentDay.toDateString() === todayString,
            timestamp: currentDay.getTime()
        })
    }

    return { days: currentWeekDays, range }
}

export function getWeekDaysForDate(
    timestamp: number,
    startWeekOn: 'sunday' | 'monday' = 'sunday'
) {
    return getWeekDaysForBaseDate(new Date(timestamp), startWeekOn)
}

export default function getCurrentWeekDays(
    weeksFromNow: number,
    startWeekOn: 'sunday' | 'monday' = 'sunday'
) {
    const baseDate = new Date()
    baseDate.setDate(baseDate.getDate() + weeksFromNow * 7)
    return getWeekDaysForBaseDate(baseDate, startWeekOn)
}

export function startOfDay(timestamp: number): number {
    const date = new Date(timestamp)
    date.setHours(0, 0, 0, 0)
    return date.getTime()
}
